<template>
  <div class="app-container">
    <!-- 搜索区域 -->
    <el-form
      :model="queryParams"
      label-position="right"
      label-width="70px"
      class="demo-form-inline"
      style="margin-bottom: 20px"
    >
      <el-row :gutter="20">
        <el-col :xs="24" :sm="24" :md="12" :lg="6">
          <el-form-item label="出库时间">
            <el-date-picker
              v-model="queryParams.useDateRange"
              type="daterange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              clearable
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-button type="primary" icon="el-icon-search" @click="handleQuery(1)"
          >搜索</el-button
        >
        <el-button @click="exportExcel">导出</el-button>
      </el-row>
    </el-form>

    <!-- 表格 -->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
     :cell-style="{ textAlign: 'center' }"
      :header-cell-style="{
        background: '#f5f7fa',
        color: '#333',
        fontWeight: 'bold',
        textAlign: 'center',
      }"
    >
      <el-table-column prop="name" label="物资/清单" />
      <el-table-column prop="creatorName" label="出库人" />
      <el-table-column prop="remark" label="备注" />
      <el-table-column prop="createTime" label="出库时间" />
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="mini" @click="handlePrint(scope.row)"
            >打印</el-button
          >
          <el-button size="mini" @click="handleView(scope.row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <pagination-bar
      :total="total"
      :page-size="pageSize"
      :current-page="currentPage"
      @update:pageSize="pageSize = $event"
      @update:currentPage="currentPage = $event"
      @page-change="handleQuery"
    />

    <!-- 查看弹窗 -->
    <view-dialog
      :visible.sync="viewDialogVisible"
      :dialog-title="'物资详情'"
      :tableData="viewForm"
      :columns="viewColumns"
      :total-items="viewTotal"
      :current-page="viewCurrentPage"
      @page-change="fetchViewData"
      @close="viewDialogVisible = false"
    />
  </div>
</template>

<script>
//   import * as XLSX from "xlsx";
//   import { saveAs } from "file-saver";
import {
  foodRecordStockInOutPage,
  foodRecordStockInOutPageDetail,
  getfoodExcelDataList,
  print,
} from "@/api/material";

import ViewDialog from "@/components/ViewDialog";
import PaginationBar from "@/components/PaginationBar";
import { downloadFile } from "@/utils/util";

export default {
  name: "OutStockRecord",
  components: {
    ViewDialog,
    PaginationBar,
  },
  data() {
    return {
      viewTotal: 0,
      viewColumns: [
        { label: "商品类型", prop: "categoryName" },
        { label: "物资名称", prop: "name" },
        { label: "单位", prop: "unit" },
        { label: "数量", prop: "num" },
        { label: "结算单价(元)", prop: "singlePrice" },
        { label: "金额", prop: "totalAmount" },
      ],
      viewId: "", //查看的ID
      viewDialogVisible: false,
      viewForm: [],
      viewPageSize: 5, // 查看弹窗分页大小
      viewCurrentPage: 1, // 查看弹窗当前页
      queryParams: {
        name: "",
        useDateRange: [],
      },
      total: 0,
      pageSize: 10,
      currentPage: 1,
      tableData: [],
    };
  },
  created() {
    this.handleQuery();
  },
  methods: {
    fetchViewData(page) {
      this.viewCurrentPage = page;
      this.handleGetView();
    },
    handleQuery(page) {
      this.currentPage = page || 1;
      foodRecordStockInOutPage({
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        type: 2, //出库
      }).then((res) => {
        this.tableData = res.records;
        this.total = res.total;
      });
    },
    resetQuery() {
      this.queryParams = {
        name: "",
        useDateRange: [],
      };
      this.currentPage = 1;
      this.handleQuery();
    },
    handleTabChange() {
      this.resetQuery();
    },
    exportExcel() {
      getfoodExcelDataList({
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        type: 2, // 类型为出库
      }).then((res) => {
        downloadFile(
          res.data,
          "食材物资出库记录.xlsx",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        );
      });
    },
    handlePrint(row) {
      console.log("打印：", row);
      const { name } = row;
      print({
        recordId: row.id,
      }).then((res) => {
        downloadFile(
          res.data,
          `${name || "食材物资"}出库单.xlsx`,
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        );
      });
    },
    handleGetView() {
      foodRecordStockInOutPageDetail({
        pageNo: this.viewCurrentPage,
        pageSize: this.viewPageSize,
        id: this.viewId,
      }).then((res) => {
        this.viewForm = res.records;
        this.viewTotal = res.total;
        this.viewDialogVisible = true;
      });
    },
    handleView(data) {
      this.viewId = data.id;
      // 处理查看操作，例如打开详情弹窗
      this.handleGetView();
    },
  },
};
</script>

<style scoped>
.app-container {
}
.el-card {
  margin-bottom: 20px;
}
</style>
